import React, { useState, createContext } from 'react';

export const DeviceSection = createContext();

const DeviceContextProvider = (props) => {
    const [devicePage, setDevicePage] = useState({ firstPage: true, scanDevice: false, allDevices: false, deviceInfo: false, endPage: false, widgetsJoined: false });

    const ShowHideDeviceFunction = (page) => {
        switch (page) {
            case "firstPage":
                setDevicePage({ firstPage: true, scanDevice: false, allDevices: false, deviceInfo: false, endPage: false, widgetsJoined: false })
                break;
            case "scanDevice":
                setDevicePage({ firstPage: false, scanDevice: true, allDevices: false, deviceInfo: false, endPage: false, widgetsJoined: false })
                break;
            case "allDevices":
                setDevicePage({ firstPage: false, scanDevice: false, allDevices: true, deviceInfo: false, endPage: false, widgetsJoined: false })
                break;
            case "deviceInfo":
                setDevicePage({ firstPage: false, scanDevice: false, allDevices: false, deviceInfo: true, endPage: false, widgetsJoined: false })
                break;
            case "endPage":
                setDevicePage({ firstPage: false, scanDevice: false, allDevices: false, deviceInfo: false, endPage: true, widgetsJoined: false })
                break;
            case "widgetsJoined":
                setDevicePage({ firstPage: false, scanDevice: false, allDevices: false, deviceInfo: false, endPage: false, widgetsJoined: true })
                break;
        }
    }

    return (
        <>
            <DeviceSection.Provider value={{ devicePage, ShowHideDeviceFunction }}>
                {props.children}
            </DeviceSection.Provider>
        </>
    );
};

export { DeviceContextProvider };